import React from 'react';
import { styled } from '@compiled/react';
import truncate from 'lodash/truncate';
import { token } from '@atlaskit/tokens';

const TRUNCATE_TEXT_LENGTH = 300;

interface DescriptionContentProps {
	isNonEmpty: boolean;
	shouldTruncateText: boolean;
	descriptionText: string | undefined;
	testId?: string;
}

export const DescriptionContent = ({
	isNonEmpty,
	shouldTruncateText,
	descriptionText,
}: DescriptionContentProps): React.JSX.Element => (
	<DescriptionContentContainer isNonEmpty={isNonEmpty}>
		{shouldTruncateText
			? truncate(descriptionText, {
					length: TRUNCATE_TEXT_LENGTH,
					separator: ' ',
				})
			: descriptionText}
	</DescriptionContentContainer>
);

type DescriptionContentContainerProps = {
	isNonEmpty: boolean;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DescriptionContentContainer = styled.div<DescriptionContentContainerProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: ({ isNonEmpty }) => (isNonEmpty ? 'inherit' : `${token('color.text.subtlest')}`),
	paddingTop: token('space.100'),
	paddingRight: token('space.075'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.075'),
	wordWrap: 'break-word',
	whiteSpace: 'pre-line',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	lineHeight: 1.2,
});
